// src/sot/primitives/SettingsCard.jsx
import React from "react";
import Card from "@/components/ui/Card.jsx";

/**
 * SettingsCard
 * - Single source of truth for doctor settings cards
 * - Used by Patients Age, Payout Preferences, Insurance Policy, etc.
 */
export default function SettingsCard({
  children,
  className = "",
  fullWidth = false,
  allowOverflow = false,
  ...props
}) {
  const classes = [
    allowOverflow ? "overflow-visible" : "overflow-hidden",
  ];

  if (fullWidth) {
    // force card to use full rail width
    classes.push("w-full", "mx-0");
  }

  if (className) {
    classes.push(className);
  }

  return (
    <Card {...props} className={classes.join(" ")}>
      {children}
    </Card>
  );
}
